import { render, staticRenderFns } from "./ProcessListChallenges.vue?vue&type=template&id=720a7161&scoped=true&"
import script from "./ProcessListChallenges.vue?vue&type=script&lang=js&"
export * from "./ProcessListChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a7161",
  null
  
)

export default component.exports